import './App.css';
import {createBrowserRouter, Navigate, Route, RouterProvider, Routes} from "react-router-dom";
import {useMemo} from "react";
import Cookies from "js-cookie";
import ScrollToTop from "./components/scrollToTop.jsx";

import Home from "./components/homeSide/home.jsx";
import Bio from "./components/bioSide/bio.jsx";
import Galerie from "./components/galerieSide/galerie.jsx";
import Technik from "./components/technikSide/technik.jsx";
import Music from "./components/musicSide/music.jsx";
import Tipps from "./components/tippsSide/tipps.jsx";
import Anfrage from "./components/anfrageSide/anfrage.jsx";
import Events from "./components/eventsSide/events.jsx";
import Login from "./components/loginSide/login.jsx";
import MusicRequestHome from "./components/musicRequestHomeSide/musicRequestHome.jsx";
import MusicRequestEvent from "./components/musicRequestEventSide/musicRequestEvent.jsx";
import Impressum from "./components/impressumSide/impressum.jsx";
import Datenschutz from "./components/datenschutzSide/datenschutz.jsx";
import PasswordReset from "./components/passwordResetSide/passwordReset.jsx";
import Deabo from "./components/deaboSide/deabo.jsx";
import Settings from "./components/settingsSide/settings.jsx";
import Administration from "./components/administrationSide/administration.jsx";
import OpenChats from "./components/openChatsSide/openChats.jsx";
import Chat from "./components/chatSide/chat.jsx";

import Footer from "./components/footer/footer.jsx";
import Navbar from "./components/navbar/navbar.jsx";
import SocialMediaOverlay from "./components/socialMediaOverlay/socialMediaOverlay.jsx";
import Cookie from "./components/cookie/cookie.jsx";

function HomeScreen() {
  return (
      <div>
        <Navbar />
        <Home />
        <Footer />
        <SocialMediaOverlay />
        <Cookie />
      </div>
  )
}

function BioScreen() {
  return (
      <div>
        <div className="layout">
            <Navbar />
            <main className="content">
                <Bio />
            </main>
            <Footer />
        </div>
      </div>
  )
}

function GalerieScreen() {
  return (
      <div>
        <div className="layout">
            <Navbar />
            <main className="content">
                <Galerie />
            </main>
            <Footer />
        </div>
      </div>
  )
}

function TechnikScreen() {
  return (
      <div>
        <div className="layout">
            <Navbar />
            <main className="content">
                <Technik />
            </main>
            <Footer />
        </div>
      </div>
  )
}

function MusicScreen() {
  return (
      <div>
        <div className="layout">
            <Navbar />
            <main className="content">
                <Music />
            </main>
            <Footer />
        </div>
      </div>
  )
}

function TippsScreen() {
  return (
      <div>
          <div className="layout">
            <Navbar />
            <main className="content">
                <Tipps />
            </main>
            <Footer />
          </div>
      </div>
  )
}

function AnfrageScreen() {
  return (
      <div>
        <div className="layout">
            <Navbar />
            <main className="content">
              <Anfrage />
            </main>
            <Footer />
          </div>
      </div>
  )
}

function EventsScreen() {
  return (
      <div className="layout">
        <Navbar />
        <main className="content">
            <Events />
        </main>
        <Footer />
      </div>
  )
}

function LoginScreen() {
  return (
      <div className="layout">
        <Navbar />
        <main className="content">
            <Login />
        </main>
        <Footer />
      </div>
  )
}

function MusicRequestHomeScreen() {
  return (
      <div className="layout">
        <Navbar />
        <main className="content">
            <MusicRequestHome />
        </main>
        <Footer />
      </div>
  )
}

function MusicRequestEventScreen() {
  return (
      <div className="layout">
        <Navbar />
        <main className="content">
            <MusicRequestEvent />
        </main>
        <Footer />
      </div>
  )
}

function ImpressumScreen() {
  return (
      <div className="layout">
        <Navbar />
        <main className="content">
            <Impressum />
        </main>
        <Footer />
      </div>
  )
}

function DatenschutzScreen() {
  return (
      <div className="layout">
        <Navbar />
        <main className="content">
            <Datenschutz />
        </main>
        <Footer />
      </div>
  )
}

function PasswordResetScreen() {
  return (
      <div className="layout">
        <Navbar />
        <main className="content">
            <PasswordReset />
        </main>
        <Footer />
      </div>
  )
}

function DeaboScreen() {
  return (
      <div className="layout">
        <main className="content">
            <Deabo />
        </main>
        <Footer />
      </div>
  )
}

function SettingsScreen() {
  return (
      <div className="layout">
        <Navbar />
        <main className="content">
            <Settings />
        </main>
        <Footer />
      </div>
  )
}

function AdministrationScreen() {
  return (
      <div className="layout">
        <main className="content">
            <Administration />
        </main>
      </div>
  )
}

function ChatScreen() {
  return (
      <div className="layout">
        <Navbar />
        <main className="content">
            <Chat />
        </main>
        <Footer />
      </div>
  )
}

function OpenChatsScreen() {
  return (
      <div className="layout">
        <Navbar />
        <main className="content">
            <OpenChats />
        </main>
        <Footer />
      </div>
  )
}

const router = createBrowserRouter([
    { path: "*", Component: Root }
])

function App() {
    const location = useMemo(() => {
        return window.location
    }, [])
  return (
      <RouterProvider router={router} />
  )
}

function Root() {
    return (
        <>
            <ScrollToTop/>
            <Routes>
                <Route path="/" element={<HomeScreen />} />
                <Route path="/bio" element={<BioScreen />} />
                <Route path="/galerie" element={<GalerieScreen />} />
                <Route path="/technik" element={<TechnikScreen />} />
                <Route path="/music" element={<MusicScreen />} />
                <Route path="/tipps" element={<TippsScreen />} />
                <Route path="/anfrage" element={<AnfrageScreen />} />
                <Route path="/events" element={<EventsScreen />} />
                <Route path="/login" element={<LoginScreen />} />
                <Route path="/musicrequesthome" element={Cookies.get("token") !== undefined ? <MusicRequestHomeScreen /> : <Navigate replace to = "/login" />} />
                <Route path="/musicrequestevent" element={Cookies.get("token") !== undefined ? <MusicRequestEventScreen /> : <Navigate replace to = "/login" />} />
                <Route path="/impressum" element={<ImpressumScreen />} />
                <Route path="/datenschutz" element={<DatenschutzScreen />} />
                <Route path="/password-reset" element={<PasswordResetScreen />} />
                <Route path="/deabo" element={<DeaboScreen />} />
                <Route path="/settings" element={Cookies.get("token") !== undefined ? <SettingsScreen /> : <Navigate replace to = "/login" />} />
                <Route path="/administration" element={(Cookies.get("token") !== undefined) && (localStorage.getItem("role") === "admin") ? <AdministrationScreen /> : <Navigate replace to = "/login" />} />
                <Route path="/chat" element={(Cookies.get("token") !== undefined) ? <ChatScreen /> : <Navigate replace to = "/login" />} />
                <Route path="/openChats" element={(Cookies.get("token") !== undefined) && (localStorage.getItem("role") === "admin") ? <OpenChatsScreen /> : <Navigate replace to = "/login" />} />
            </Routes>
        </>
    )
}

export default App;
